import React from 'react';

/**
 * StoryCardList — reusable presentational component for story/news/event card grids.
 *
 * Replaces the 40-55 line pattern duplicated across event, fellowship, project,
 * pressRelease, and eventsLanding templates.
 *
 * Props:
 *   items            (array, required)   — story objects to render
 *   sectionId        (string)            — id attribute for the wrapper div
 *   heading          (string)            — h2 text
 *   getImageUrl      (function)          — (item) => url string
 *                                          Default: item?.featured_image?.sizes?.hero_sm ?? ''
 *   styles           (object, required)  — CSS module from the consuming template
 *   wrapperClassName (string)            — override wrapper class; defaults to styles.fellowshipStories
 */
const StoryCardList = ({
  items,
  sectionId,
  heading,
  getImageUrl,
  styles,
  wrapperClassName,
}) => {
  if (!items || items.length === 0) {
    return null;
  }

  const resolveImageUrl = getImageUrl || ((item) => item?.featured_image?.sizes?.hero_sm ?? '');
  const wrapperClass = wrapperClassName || styles.fellowshipStories;

  return (
    <div
      id={sectionId}
      className={wrapperClass}
    >
      <h2 className={`${styles.sectionHeading}`}>
        {heading}
      </h2>
      <div
        className={`${styles.sectionInset}`}
      >
        {items.map(function(item, i) {
          return (
            <div
              key={item.path || i}
              className={`${styles.sectionItem}`}
            >
              <a href={item.path}>
                <div
                  className={`${styles.storyImg}`}
                  style={{ backgroundImage: `url(${resolveImageUrl(item)})` }}
                ></div>
              </a>
              <h3
                className={`${styles.storyTitle}`}
              >
                <a href={item.path}>
                  {item.title}&nbsp;<span className={styles.angle}>&#8250;</span>
                </a>
              </h3>
            </div>
          );
        })}

      </div>
    </div>
  );
};

export default StoryCardList;
